export default "__VITE_ASSET__BtCnc3iM__"